// const source = 'podsDataTable'

function uploadRcuUnicoFile () {

  

    this.$eventBus.emit('show-dialog-page', {
      page: 'pdrs-rcu-unico',
      title: 'Rcu Unico Gas',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': uploadRcuUnicoFile,
}
